import React, { FunctionComponent } from "react";
import { Grid } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import cs from "classnames";
import { useTranslation } from "react-i18next";
import { MarPointTableRecord } from "/src/domain/challenges/ChallengeProtocolData";
import { MarPointRecordView } from "../marPoints/MarPointRecordView";


export type ProgressTableProps = {
    className?: string,
    records: MarPointTableRecord[],
    title?: string
};

export const ProgressTable: FunctionComponent<ProgressTableProps> = ({ className, records, title }) => {
    const { t } = useTranslation();
    const classes = useStyles();

    return (
        <div className={cs(className, classes.container)}>
            <h3 className={classes.header}>{Boolean(title) ? title : t('progressTableHeader')}</h3>
            <Grid container
                className={classes.tableHeader}
                justifyContent="center"
                alignItems="center"
            >
                <Grid item container xs={11} spacing={1}>
                    <Grid item xs={1} >
                    </Grid>
                    <Grid item xs={1} className={classes.headerCell}>
                        #
                    </Grid>
                    <Grid item xs={6} className={classes.headerCell}>
                        {t('name')}
                    </Grid>
                    <Grid item container xs={4} justifyContent="flex-end" className={classes.headerCell}>
                        {t('progress_in_sec')}
                    </Grid>
                </Grid>
            </Grid>
            {records.map((r, i) => <MarPointRecordView key={i} record={r} place={i + 1} />)}
        </div>
    );
};

const useStyles = makeStyles((muiTheme) => ({
    container: {
        marginTop: "2rem"
    },
    header: {},
    tableHeader: {
        width: '100%',
        margin: 0,
        height: '2.5rem',
        marginTop: '0.5rem',
        fontSize: '0.9rem',
        fontWeight: 500,
        color: muiTheme.palette.primary.main,
        padding: '0.5rem 0',
    },
    headerCell: {
        overflowX: 'auto',
    }
}));